/** Оставшееся время до сброса дневного лимита (resets_at - ISO UTC от API). */
export function formatDailyResponsesCountdown(resetsAt: string, nowMs = Date.now()): string {
  const target = new Date(resetsAt).getTime();
  if (!Number.isFinite(target)) {
    return ' - ';
  }
  const diff = Math.max(0, target - nowMs);
  const hours = Math.floor(diff / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  if (hours > 0) {
    return `${hours} ч ${minutes} мин`;
  }
  if (minutes > 0) {
    return `${minutes} мин`;
  }
  return 'скоро';
}

export function formatDailyResponsesResetLabel(): string {
  return '00:00 по московскому времени';
}
